import React, { Component } from 'react';

import { css } from 'aphrodite/no-important';
import styles from './HistoryMap.styles';

import {
  drawArea,
  drawZones,
  drawHistory,
  clearLayers
} from '../../../utils/mapgl';

import DateBar from '../../common/datebar/DateBar';
import EventList from './EventList';
import MapGL from '../../data/mapgl/MapGL';
import PlayButton from './PlayButton';


const COLOR  = '#faff67';

function removeMarker(map){
  if(map.getLayer('selected-event')){
    map.removeLayer('selected-event');
    map.removeSource('selected-event');
  }
}

function clearHistory(map){
  let l = map.getLayer('tag-history');
  if(l){
    map.removeLayer(l.id);
  }
  let s = map.getSource('tag-history-data');
  if(s){
    map.removeSource(s.id);
  }
}

function createMarker(coords, map){
  removeMarker(map);

  let s = {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: coords
      }
    }
  }

  map.addSource('selected-event', s);
  map.addLayer({
    id: 'selected-event',
    source: 'selected-event',
    type:'circle',
    paint: {
      'circle-radius': 
      {
        stops: [[1, 4], [8,6], [10,8]]
      },
      'circle-color': COLOR,
      'circle-blur': 0,
      'circle-stroke-width': 6,
      'circle-stroke-opacity': 0,
      'circle-stroke-color': COLOR
    }
  });
}

class HistoryMap extends Component {
  state = {
    reload: true,
    reset: false,
    currentTag: false
  };
  styled = false;
  map = null;
  marker = null;
  componentDidUpdate(prev){
    if(!this.props.history || this.props.history.length === 0){
      if(!prev.history || prev.history.features.length === 0){
        return;
      }
      this.setState({reset: true, currentTag: false})
    }
  }
  onLoad = map => {
    this.map = map;
    const { history, area, zones } = this.props;
    if(!history){
      clearLayers(map);
      clearHistory(map);
      removeMarker(map);
    }
    if(history && history.features.length === 0){
      if(this.state.styled){
        drawArea(map, area, false);
        drawZones(map, zones && area.id in zones ? zones[area.id] : [], {}, {});
        this.styled = false;
      }
      drawHistory(
        map,
        history
      );
      return;
    }

    if (history && history.features.length && this.state.reload) {
      if (this.state.animation) {
        this.state.animation.stop();
      }
      removeMarker(map);
      clearLayers(map);
      drawArea(map, area, false);
      drawZones(map, zones && area.id in zones ? zones[area.id] : [], {}, {});
      drawHistory(
        map,
        history,
        animation => this.setState({ animation })
      );
      this.setState({reload: false });

    }
  };
  dateClickHandler = (startDate, endDate) => {
    this.props.showHistory(startDate, endDate);
    this.setState({ reload: true});
  };

  showMarker(coords){
    createMarker(coords, this.map);    
  }

  eventClickHandler = (idx, d)=>{
    this.showMarker(d.coordinates);
    this.setState({currentTag: idx});
  };

  onStyleChange = () => {
    this.styled = true;
    this.setState({ reload: true });
  };
  
  startAnimation(map, data){
    let that = this;
    let ct = this.state.currentTag || 0;
    function animateMarker(){
      if(ct >= data.length){
        removeMarker(map);
        that.setState({reset: true, currentTag: false})
        return;
      }
      if(!that.playing){
        return;
      }
      createMarker(data[ct].coordinates, map);
      
      that.setState({currentTag: ct});
      ct +=1;
      setTimeout(()=>{
        requestAnimationFrame(animateMarker);
      },300);
    }
  
    requestAnimationFrame(animateMarker);
    
  };
  
  handlePlay = (playing)=>{
    this.playing= playing;
    if(playing){
      this.setState({reset: false})
      this.startAnimation(this.map, this.props.list);
    }
  };

  handleMarkerClick = (e) => {
    let features = this.map.queryRenderedFeatures(e.point, { layers: ['tag-history'] });
    if (!features.length) {
        return;
    }
  };
  render() {
    let s =(this.props.history && this.props.history.features.length > 0)?styles.show: styles.hide;
    return (
      <div className={css(styles.base)}>
        <DateBar handleClick={this.dateClickHandler} />
        <EventList data={this.props.list} 
          containerId="map-container"
          onClick={this.eventClickHandler}
          currentTag={this.state.currentTag}/>
        <MapGL
          styles={styles.map}
          type="default"
          onLoad={this.onLoad}
          onUpdate={this.onLoad}
          onMove={this.props.onMove}
          onStyleChange={this.onStyleChange}
          options={this.props.options}
          showSuperTagLegend={false}
        />
         <PlayButton styles={s} onClick={this.handlePlay} reset={this.state.reset}/>
      </div>
    );
  }
}

export default HistoryMap;


// WEBPACK FOOTER //
// ./src/components/data/historymap/HistoryMap.js